// @ts-nocheck
import * as Types from '../../../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { LocationsSelectField_LocationFragmentDoc } from '../../../../../../components/autoPopulateSelects/LocationsSelectField.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AddEditItemModal_GetLocationsQueryVariables = Types.Exact<{
  rpavId: Types.Scalars['ID']['input'];
}>;


export type AddEditItemModal_GetLocationsQuery = { __typename?: 'Query', locations: Array<{ __typename?: 'Location', id: string, name: string, path?: string | null | undefined, displayLocationPath: string, type: { __typename?: 'LocationTypeDetail', code: Types.LocationType, name: string } }> };


export const AddEditItemModal_GetLocationsDocument = gql`
    query AddEditItemModal_GetLocations($rpavId: ID!) {
  locations(filter: {rpav: [$rpavId], scope: false, version: [2]}) {
    ...LocationsSelectField_Location
  }
}
    ${LocationsSelectField_LocationFragmentDoc}`;

/**
 * __useAddEditItemModal_GetLocationsQuery__
 *
 * To run a query within a React component, call `useAddEditItemModal_GetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddEditItemModal_GetLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddEditItemModal_GetLocationsQuery({
 *   variables: {
 *      rpavId: // value for 'rpavId'
 *   },
 * });
 */
export function useAddEditItemModal_GetLocationsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AddEditItemModal_GetLocationsQuery, AddEditItemModal_GetLocationsQueryVariables> & ({ variables: AddEditItemModal_GetLocationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AddEditItemModal_GetLocationsQuery, AddEditItemModal_GetLocationsQueryVariables>(AddEditItemModal_GetLocationsDocument, options);
      }
export function useAddEditItemModal_GetLocationsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AddEditItemModal_GetLocationsQuery, AddEditItemModal_GetLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AddEditItemModal_GetLocationsQuery, AddEditItemModal_GetLocationsQueryVariables>(AddEditItemModal_GetLocationsDocument, options);
        }
// @ts-ignore
export function useAddEditItemModal_GetLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AddEditItemModal_GetLocationsQuery, AddEditItemModal_GetLocationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddEditItemModal_GetLocationsQuery, AddEditItemModal_GetLocationsQueryVariables>;
export function useAddEditItemModal_GetLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddEditItemModal_GetLocationsQuery, AddEditItemModal_GetLocationsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AddEditItemModal_GetLocationsQuery | undefined, AddEditItemModal_GetLocationsQueryVariables>;
export function useAddEditItemModal_GetLocationsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AddEditItemModal_GetLocationsQuery, AddEditItemModal_GetLocationsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AddEditItemModal_GetLocationsQuery, AddEditItemModal_GetLocationsQueryVariables>(AddEditItemModal_GetLocationsDocument, options);
        }
export type AddEditItemModal_GetLocationsQueryHookResult = ReturnType<typeof useAddEditItemModal_GetLocationsQuery>;
export type AddEditItemModal_GetLocationsLazyQueryHookResult = ReturnType<typeof useAddEditItemModal_GetLocationsLazyQuery>;
export type AddEditItemModal_GetLocationsSuspenseQueryHookResult = ReturnType<typeof useAddEditItemModal_GetLocationsSuspenseQuery>;
export type AddEditItemModal_GetLocationsQueryResult = Apollo.QueryResult<AddEditItemModal_GetLocationsQuery, AddEditItemModal_GetLocationsQueryVariables>;